// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__F0cEq"};